import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

type QuoteRequestReference = ClientInferRequest<
  typeof contract.quoteRequests.updateReference
>["body"]["reference"];

type QuoteRequestUpdateReferenceResponse = ClientInferResponseBody<
  typeof contract.quoteRequests.updateReference
>;

export const updateQuoteRequestReference = async ({
  id,
  reference,
}: {
  id: string;
  reference: QuoteRequestReference;
}): Promise<QuoteRequestUpdateReferenceResponse | null> => {
  const response = await api.quoteRequests.updateReference.mutation({
    body: { reference },
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
